import { useRouter } from 'next/router';

export const useIsTablePayPage = () => {
  const router = useRouter();
  const isPayCheckRoute =
    router.pathname === '/[locationSlug]/[merchantSlug]/[merchantId]/pay/[checkId]';
  return isPayCheckRoute && !!router.query.table;
};
